/* eslint-disable */
import { api } from '@creditsights/api-ui-web';
import { addDateFilter } from '../utils/date.utils';
import { filterMapper } from '../utils/filter.utils';
import { fetchFilters } from './filter.service';

const API_PREFIX = 'document-search';
export const fetchDocumentSearchData = async (docType, sort, text, reportType, filters, pageSize, page = 1): Promise<any> => {
  const { data } = await api.post(`${API_PREFIX}/${docType}s/search`, {
    text,
    docType: reportType,
    filters,
    skip: (page - 1) * pageSize,
    take: pageSize,
    sort: sort?.field,
    sortDesc: sort?.order === 'desc',
  });

  data.results.forEach((item: any, index) => {
    item.key = `${item.id}-${index}-${item.docType}`;
  });

  return data;
};

export const fetchDocumentSearchFilterData = async (docType): Promise<any> => {
  const array: any[] = [];
  const [{ data }, filters] = await Promise.all([api.get(`${API_PREFIX}/${docType}s/filters`), fetchFilters()]);
  let coveredCountries: any = {};

  data.forEach((item) => {
    if (item.id === 'countries') {
      item.data.forEach((i) => (coveredCountries[i] = true));
    } else {
      array.push({
        ...item,
        data: filterMapper(item.data),
      });
    }
  });

  array.splice(1, 0, {
    id: 'creditGrade',
    name: 'Credit Grade',
    data: filters.config.creditGrade,
  });

  array.splice(1, 0, {
    id: 'countries',
    name: 'Country',
    data: filters.config.country.filter((i: any) => coveredCountries[i.key]),
  });

  array.splice(1, 0, {
    id: 'region',
    name: 'Region',
    data: filters.config.region,
  });

  array.splice(1, 0, {
    id: 'sector',
    name: 'Sectors',
    data: filters.config.sector,
  });

  return array;
};
